import { GraphQL } from '@guestgoodie/graphql'

export function logoPreview(
  file: GraphQL.FileFragmentFragment,
  backgroundHex?: string | null
) {
  const bg = backgroundHex ? backgroundHex.replace('#', '') : 'FFFFFF'

  return `${import.meta.env.VITE_IMGPROXY_URL}/_/resize:fit:64:64/extend:t/background:${bg}/plain/${file.token}.${file.extension}`
}
